var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"children-dialog",attrs:{"visible":_vm.visible,"fullscreen":"","append-to-body":""},on:{"close":_vm.closeDialog}},[_c('children-tabs',{attrs:{"default-children":_vm.children,"current-row":_vm.currentRow,"formRuntimeDialog":_vm.formRuntimeDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4727d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/runtime/children-dialog.vue
// module id = null
// module chunks = 